var all_roles = [
	"hospital_admin",
	"hotel_admin",
	"reception"
]


module.exports = {
	"dashboard": {
		"checkin": all_roles,
		"checkout": all_roles
	},

	"rooms": {
		"roomList": all_roles,
		"roomsConsolidated": ["hotel_admin", "hospital_admin"],
		"roomControl": ["hotel_admin", "hospital_admin"],
		"configureDevices": ["hotel_admin", "hospital_admin"],
		"pairLock": ["hotel_admin", "hospital_admin"],
		"postEventActions": ["hotel_admin", "hospital_admin"],
		"manageRemotes": ["hotel_admin", "hospital_admin"],
		"manageScenes": ["hotel_admin", "hospital_admin"],
		"manageThermostats": ["hotel_admin", "hospital_admin"],
		"multilevel": true
	},

	"stats": {
		"powerCharts": ["hotel_admin", "hospital_admin"],
		"checkinStats": ["hotel_admin", "hospital_admin"],
		"multilevel": true

	},

	"promotions": {
		"create": ["hotel_admin", "hospital_admin"],
		"view": ["hotel_admin", "hospital_admin"]
	},

	"services": {
		"requests": ["hotel_admin", "hospital_admin", "service_manager"],
		"manage": [
			"hotel_admin"
		],
		"service_crud": [
			"hospital_admin"
		],
		"service_assign_button": [
			"hospital_admin"
		],
		"multilevel": true
	},

	"directory": {
		"directoryList": ["hotel_admin"],
		"newNumber": ["hotel_admin"]
	},

	"wifi": {
		"newwifi": ["hotel_admin"],
		"wifilist": ["hotel_admin"]
	},

	"lock": {
		"movelock": ["hotel_admin"],
		"movelockbackToHome":["hotel_admin"]
	},

	"smartlockcards": {
		"smartlockcards": ["hotel_admin"]
	},

	"food": {
		"foodList": ["hotel_admin"],
		"newFood": ["hotel_admin"]
	},

	"feedback": {
		"feedbackTemplateList": ["hotel_admin"],
		"newFeedbackTemplate": ["hotel_admin"],
    "listFeedbackTemplate": ["hotel_admin"],
    "feedbackResponses": ["hotel_admin"],
		"multilevel": true
	},

	"users": {
		"userList": ["hotel_admin", "hospital_admin"],
		"newUser": ["hotel_admin", "hospital_admin"]
	},

	"schedule": {
		"scheduleList": ["hotel_admin", "hospital_admin"],
		"newSchedule": ["hotel_admin", "hospital_admin"]
	},

	"settings": {
		"alertSettings": ["hotel_admin", "hospital_admin"]
	},

	"integration": {
		"generateNewToken": ["hotel_admin"]
	}
}


// WEBPACK FOOTER //
// ./config/roles.js